



























import {
  defineComponent,
  PropType,
  ref,
  onMounted
} from '@nuxtjs/composition-api';
import useWindowResize from '~/hooks/useResizeWindow';

export type CombiDeal = {
  medias: string[];
  combi_description: string;
  fixed_list_price: number;
  media_file_name: string;
  media_guid: string;
  spli_reference: number;
  accessorie_tag: string;
  url_safe_name: string;
  end_of_life: true;
  available_stock: true;
  path_to_page: string;
  discount: number;
  _id: number;
  combinedIds: number[];
};

export default defineComponent({
  name: 'CombiDeals',
  props: {
    combideals: {
      type: Array as PropType<CombiDeal[]>,
      default: () => []
    },
    firstProduct: {
      type: Object,
      default: () => ({})
    },
    productSpliId: {
      type: Number,
      required: true,
      default: 0
    }
  },
  setup(props) {
    const combiDeals = ref(JSON.parse(JSON.stringify(props.combideals)));

    onMounted(() => {
      if (combiDeals.value.length > 0) {
        const firstProduct = props.firstProduct;
        combiDeals.value[0].combi_description =
          firstProduct.name + ' + ' + combiDeals.value[0].combi_description;
        combiDeals.value[0].medias = [
          `${firstProduct.product_image_gallery?.[0]?.media_url}`,
          `/media/${combiDeals.value[0].media_guid}/${combiDeals.value[0].media_file_name}`
        ];
        combiDeals.value[0].alts = [
          firstProduct.media_file_name,
          combiDeals.value[0].media_file_name
        ];
        combiDeals.value[0].fixed_list_price += firstProduct.price;
        combiDeals.value[0].combinedIds = [combiDeals.value[0]._id];
        combiDeals.value[0].can_be_ordered = props.firstProduct.can_be_ordered;
        combiDeals.value.reduce((previousProduct, total) => {
          total.combinedIds = [...previousProduct.combinedIds, total._id];
          total.fixed_list_price += previousProduct?.fixed_list_price;
          total.discount += previousProduct?.discount;
          total.combi_description = `${previousProduct.combi_description} + ${total.combi_description}`;
          total.can_be_ordered =
            previousProduct.can_be_ordered && total.can_be_ordered;
          if (typeof previousProduct?.medias === 'undefined') {
            const previousProductMedia = `/media/${previousProduct?.media_guid}/${previousProduct?.media_file_name}`;
            previousProduct.medias = [previousProductMedia];
            total.medias = [
              previousProductMedia,
              `/media/${total?.media_guid}/${total?.media_file_name}`
            ];
            total.alts = [
              previousProduct.media_file_name,
              total.media_file_name
            ];
          } else {
            total.medias = previousProduct.medias.concat(
              `/media/${total?.media_guid}/${total?.media_file_name}`
            );
            total.alts = [...previousProduct.alts, total.media_file_name];
          }

          return total;
        });
      }
    });

    return {
      combiDeals
    };
  }
});
